export enum PasswordForgotFormNames {
    EMAIL = "email",
}

export type PasswordForgotFormData = Record<PasswordForgotFormNames, string>;
